import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import './Cronometraje.css';

const Cronometraje = () => {
  const [time, setTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [activeFeature, setActiveFeature] = useState('precision');

  // Simulador de cronómetro
  useEffect(() => {
    let interval;
    if (isRunning) {
      interval = setInterval(() => {
        setTime(prevTime => prevTime + 10);
      }, 10);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isRunning]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60000);
    const seconds = Math.floor((time % 60000) / 1000);
    const milliseconds = Math.floor((time % 1000) / 10);
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}.${milliseconds.toString().padStart(2, '0')}`;
  };

  const features = [
    {
      id: 'precision',
      title: 'Precisión Milimétrica',
      description: 'Tecnología que garantiza exactitud hasta la centésima de segundo',
      icon: '/images/ic1.png'
    },
    {
      id: 'tecnologia',
      title: 'Tecnología de Vanguardia',
      description: 'Sistemas automáticos con sensores de última generación',
      icon: '/images/ic2.png'
    },
    {
      id: 'resultados',
      title: 'Resultados en Tiempo Real',
      description: 'Visualización inmediata de clasificaciones y estadísticas',
      icon: '/images/ic3.png'
    }
  ];

  return (
    <div className="cronometraje-page">
                      {/* Agregar el Header */}
                      <Header 
                userRole={null}
                username={null} 
                handleLogout={() => {}} 
                setModalOpen={() => {}} 
                setRegisterModalOpen={() => {}} 
            />
      {/* Hero Section con Cronómetro Animado */}
      <section className="chrono-hero" style={{backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url('/images/c3.jpg')`}}>
        <div className="hero-content">
          <h1>Cronometraje <span>Preciso</span> y <span>Confiable</span></h1>
          <p>Tecnología de punta para eventos deportivos profesionales</p>
          
          {/* Simulador de cronómetro interactivo */}
          <div className="chrono-demo">
            <div className="chrono-display">{formatTime(time)}</div>
            <div className="chrono-controls">
              <button 
                onClick={() => setIsRunning(!isRunning)}
                className={isRunning ? 'stop-btn' : 'start-btn'}
              >
                {isRunning ? 'Detener' : 'Iniciar'}
              </button>
              <button 
                onClick={() => setTime(0)}
                className="reset-btn"
              >
                Reiniciar
              </button>
            </div>
            <p className="demo-text">Simulador interactivo - Nuestra tecnología real es 100x más precisa</p>
          </div>
        </div>
      </section>

      {/* Sección de Introducción */}
      <section className="intro-section">
        <div className="intro-image">
          <img src="/images/c4.jpg" alt="Equipo de cronometraje" />
          <div className="tech-badge">
            <span>Tecnología Certificada</span>
          </div>
        </div>
        <div className="intro-content">
          <h2>En INNOVATES SPORT</h2>
          <p>
            Nos enfocamos en proporcionar un servicio de cronometraje preciso y confiable para eventos 
            deportivos de bici montaña y running. Nuestro equipo de expertos utiliza la última tecnología 
            para garantizar tiempos exactos y resultados confiables.
          </p>
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-value">99.9%</div>
              <div className="stat-label">Precisión</div>
            </div>
            <div className="stat-item">
              <div className="stat-value">500+</div>
              <div className="stat-label">Eventos</div>
            </div>
            <div className="stat-item">
              <div className="stat-value">0.001s</div>
              <div className="stat-label">Margen de error</div>
            </div>
          </div>
        </div>
      </section>

      {/* Sección de Características */}
      <section className="features-section">
        <h2 className="section-title">Tecnología de Vanguardia</h2>
        <p className="section-subtitle">Sistemas profesionales para eventos de alto rendimiento</p>
        
        <div className="features-tabs">
          {features.map(feature => (
            <button
              key={feature.id}
              className={`feature-tab ${activeFeature === feature.id ? 'active' : ''}`}
              onClick={() => setActiveFeature(feature.id)}
            >
              <img src={feature.icon} alt={feature.title} />
              {feature.title}
            </button>
          ))}
        </div>
        
        <div className="feature-content">
          {activeFeature === 'precision' && (
            <div className="tech-detail">
              <div className="tech-description">
                <h3>Sistemas de Cronometraje Automático</h3>
                <ul>
                  <li>Precisión hasta 1/1000 de segundo</li>
                  <li>Sensores RFID para registro automático</li>
                  <li>Tecnología anti-interferencias</li>
                  <li>Funcionamiento en condiciones extremas</li>
                </ul>
              </div>
              <div className="tech-image">
                <img src="/images/c5.jpg" alt="Tecnología de precisión" />
              </div>
            </div>
          )}
          
          {activeFeature === 'tecnologia' && (
            <div className="tech-detail">
              <div className="tech-description">
                <h3>Equipos de Última Generación</h3>
                <ul>
                  <li>Sensores de velocidad y distancia láser</li>
                  <li>Software de análisis de datos en tiempo real</li>
                  <li>Pantallas de visualización para espectadores</li>
                  <li>Sistemas redundantes para máxima confiabilidad</li>
                </ul>
              </div>
              <div className="tech-image">
                <img src="/images/c6.jpg" alt="Dispositivos tecnológicos" />
              </div>
            </div>
          )}
          
          {activeFeature === 'resultados' && (
            <div className="tech-detail">
              <div className="tech-description">
                <h3>Reportes y Visualización</h3>
                <ul>
                  <li>Clasificaciones actualizadas al instante</li>
                  <li>App para participantes con estadísticas</li>
                  <li>Certificados digitales con datos de carrera</li>
                  <li>Medallas personalizadas con tecnología NFC</li>
                </ul>
              </div>
              <div className="tech-image">
                <img src="../images/c7.jpg" alt="Pantalla de resultados" />
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Sección de Servicios */}
      <section className="services-section">
        <div className="services-header">
          <h2>Servicios de Cronometraje Personalizados</h2>
          <p>Soluciones adaptadas a cada tipo de evento deportivo</p>
        </div>
        
        <div className="services-grid">
          <div className="service-card">
            <div className="service-icon">
              <img src="/images/c8.jpg" alt="Individual" />
            </div>
            <h3>Cronometraje Individual</h3>
            <p>Tiempos precisos para cada participante con splits por segmentos</p>
          </div>
          
          <div className="service-card">
            <div className="service-icon">
              <img src="/images/c4.jpg" alt="Equipos" />
            </div>
            <h3>Por Equipos</h3>
            <p>Sistemas para relevos y competencias por equipos con transiciones</p>
          </div>
          
          <div className="service-card">
            <div className="service-icon">
              <img src="/images/2.jpeg" alt="Resultados" />
            </div>
            <h3>Resultados en Tiempo Real</h3>
            <p>Plataforma online y pantallas físicas con clasificaciones</p>
          </div>
          
          <div className="service-card">
            <div className="service-icon">
              <img src="/images/c9.jpg" alt="Certificados" />
            </div>
            <h3>Certificados Digitales</h3>
            <p>Documentos oficiales con todos los datos de la competencia</p>
          </div>
        </div>
      </section>

      {/* Sección de Experiencia */}
      <section className="experience-section">
        <div className="experience-content">
          <h2>Experiencia y Expertise</h2>
          <p>
            Nuestro equipo tiene años de experiencia en eventos de bici montaña y running. 
            Hemos cronometrado desde carreras locales hasta campeonatos internacionales, 
            garantizando siempre la máxima precisión.
          </p>
          
          <div className="event-types">
            <div className="event-type">
              <img src="/images/3.jpg" alt="MTB" />
              <h4>Carreras MTB</h4>
            </div>
            <div className="event-type">
              <img src="/images/run.jpg" alt="Trail" />
              <h4>Trail Running</h4>
            </div>
            <div className="event-type">
              <img src="/images/ruta.jpg" alt="Ruta" />
              <h4>Carreras de Ruta</h4>
            </div>
          </div>
        </div>
        <div className="experience-image">
          <img src="/images/c2.png" alt="Equipo trabajando" />
        </div>
      </section>

      {/* Sección de Contacto */}
      <section className="contact-section">
        <div className="contact-card">
          <h2>¿Necesitas cronometraje profesional?</h2>
          <p>Contáctanos para garantizar la precisión de tu evento deportivo</p>
          <Link to="/contacto" className="cta-button">Solicitar Servicio</Link>
        </div>
      </section>
    </div>
  );
};

export default Cronometraje;